import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

// prettier-ignore
const PickOrder = () => import('@/entities/pick-order/pick-order.vue');
// prettier-ignore
const PickOrderView = () => import('@/entities/pick-order/pick-order-view.vue');
// prettier-ignore
const PickOrderEdit = () => import('@/entities/pick-order/pick-order-edit.vue');
// prettier-ignore
const PickOrderCreate = () => import('@/entities/pick-order/pick-order-create.vue');
// prettier-ignore
const Building = () => import('@/entities/building/building.vue');
// prettier-ignore
const BuildingView = () => import('@/entities/building/building-view.vue');
// prettier-ignore
const BuildingEdit = () => import('@/entities/building/building-edit.vue');
// prettier-ignore
const BuildingCreate = () => import('@/entities/building/building-create.vue');
// prettier-ignore
const BuildingGroup = () => import('@/entities/building-group/building-group.vue');
// prettier-ignore
const BuildingGroupView = () => import('@/entities/building-group/building-group-view.vue');
// prettier-ignore
const BuildingGroupEdit = () => import('@/entities/building-group/building-group-edit.vue');
// prettier-ignore
const BuildingGroupCreate = () => import('@/entities/building-group/building-group-create.vue');
// prettier-ignore
const Location = () => import('@/entities/location/location.vue');
// prettier-ignore
const LocationView = () => import('@/entities/location/location-view.vue');
// prettier-ignore
const LocationEdit = () => import('@/entities/location/location-edit.vue');
// prettier-ignore
const LocationCreate = () => import('@/entities/location/location-create.vue');
// prettier-ignore
const Item = () => import('@/entities/item/item.vue');
// prettier-ignore
const ItemView = () => import('@/entities/item/item-view.vue');
// prettier-ignore
const ItemEdit = () => import('@/entities/item/item-edit.vue');
// prettier-ignore
const ItemCreate = () => import('@/entities/item/item-create.vue');
// prettier-ignore
const UomUsage = () => import('@/entities/uom-usage/uom-usage.vue');
// prettier-ignore
const UomUsageView = () => import('@/entities/uom-usage/uom-usage-view.vue');
// prettier-ignore
const UomUsageEdit = () => import('@/entities/uom-usage/uom-usage-edit.vue');
// prettier-ignore
const UomUsageCreate = () => import('@/entities/uom-usage/uom-usage-create.vue');
// prettier-ignore
const Uom = () => import('@/entities/uom/uom.vue');
// prettier-ignore
const UomView = () => import('@/entities/uom/uom-view.vue');
// prettier-ignore
const UomEdit = () => import('@/entities/uom/uom-edit.vue');
// prettier-ignore
const UomCreate = () => import('@/entities/uom/uom-create.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'pick-order',
      name: 'PickOrder',
      component: PickOrder,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'pick-order/new',
      name: 'PickOrderCreate',
      component: PickOrderCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'pick-order/:pickOrderId/edit',
      name: 'PickOrderEdit',
      component: PickOrderEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'pick-order/:pickOrderId/view',
      name: 'PickOrderView',
      component: PickOrderView,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building',
      name: 'Building',
      component: Building,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building/new',
      name: 'BuildingCreate',
      component: BuildingCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building/:buildingId/edit',
      name: 'BuildingEdit',
      component: BuildingEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building/:buildingId/view',
      name: 'BuildingView',
      component: BuildingView,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building-group',
      name: 'BuildingGroup',
      component: BuildingGroup,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building-group/new',
      name: 'BuildingGroupCreate',
      component: BuildingGroupCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building-group/:buildingGroupId/edit',
      name: 'BuildingGroupEdit',
      component: BuildingGroupEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'building-group/:buildingGroupId/view',
      name: 'BuildingGroupView',
      component: BuildingGroupView,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'location',
      name: 'Location',
      component: Location,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'location/new',
      name: 'LocationCreate',
      component: LocationCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'location/:locationId/edit',
      name: 'LocationEdit',
      component: LocationEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'location/:locationId/view',
      name: 'LocationView',
      component: LocationView,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'item',
      name: 'Item',
      component: Item,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'item/new',
      name: 'ItemCreate',
      component: ItemCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'item/:itemId/edit',
      name: 'ItemEdit',
      component: ItemEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'item/:itemId/view',
      name: 'ItemView',
      component: ItemView,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom-usage',
      name: 'UomUsage',
      component: UomUsage,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom-usage/new',
      name: 'UomUsageCreate',
      component: UomUsageCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom-usage/:uomUsageId/edit',
      name: 'UomUsageEdit',
      component: UomUsageEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom-usage/:uomUsageId/view',
      name: 'UomUsageView',
      component: UomUsageView,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom',
      name: 'Uom',
      component: Uom,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom/new',
      name: 'UomCreate',
      component: UomCreate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom/:uomId/edit',
      name: 'UomEdit',
      component: UomEdit,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'uom/:uomId/view',
      name: 'UomView',
      component: UomView,
      meta: { authorities: [Authority.ADMIN] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
